<script setup lang="ts">
import { computed } from 'vue';

import TextCheckOptions from '@/components/Jobs/CopilotActivation/TextCheckOptions.vue';
import ScreeningQuestionsForm from '@/components/Jobs/CopilotActivation/ScreeningOptions/ScreeningQuestionsForm.vue';
import Divider from '@/components/Shared/Divider/Divider.vue';
import type { DynamicScreeningQuestion } from '@factoryfixinc/ats-interfaces';

const props = defineProps<{
  isSelected: boolean;
  isPolicyLocked?: boolean;
  isDisabled?: boolean;
  questions?: DynamicScreeningQuestion[];
}>();

const emit = defineEmits<{
  (e: 'select'): void;
  (e: 'update:questions', value: DynamicScreeningQuestion[]): void;
}>();

const isOptionLocked = computed(() => props.isDisabled || props.isPolicyLocked);

const questionsModel = computed<DynamicScreeningQuestion[]>({
  get: () => props.questions ?? [],
  set: (value) => {
    emit('update:questions', value);
  },
});

function handleSelect() {
  if (isOptionLocked.value) {
    return;
  }

  emit('select');
}
</script>

<template>
  <div class="relative" :class="{ 'opacity-75': isOptionLocked }">
    <TextCheckOptions
      :is-selected="isSelected"
      :is-disabled="isOptionLocked"
      :is-policy-locked="isPolicyLocked"
      @click="handleSelect"
    >
      <template #title>Interview and dig deeper</template>
      Review their resume and ask meaningful questions to get the full picture

      <template v-if="isSelected" #action>
        <Divider class="my-3" />
        <ScreeningQuestionsForm v-model:questions="questionsModel" :is-disabled="isOptionLocked" />
      </template>
    </TextCheckOptions>
  </div>
</template>
